import React from "react";
import { Route, Switch } from "react-router-dom";

import useAuth from "utils/auth/hooks";
import Login from "pages/Login/Login";
import ChangePassword from "pages/ChangePassword"
import Maintenance from "pages/Maintenance";

const PublicLayout = () => {
  const { data } = useAuth();

  if (process.env.REACT_APP_MAINTENANCE_MODE === 'true') {
    return (
      <Switch>
        <Route path="/" component={Maintenance} />
      </Switch>
    );
  }

  return data.userData?.userInfo?.requirePasswordChange ? (
      <Switch>
        <Route path="/" component={ChangePassword} />
      </Switch>
    ) : data.isLoggedIn ? null 
    : (<Switch>
        <Route path="/" component={Login} />
      </Switch>
      );
};

export default PublicLayout;
